const AMENITIES_AVAILABILITY_CONSTANTS = {
    NOT_LISTED: 'Not Listed',
    YES: 'Yes',
    NO: 'No',
};

const makeDefaultAmenities = () => ({
    parking: AMENITIES_AVAILABILITY_CONSTANTS.NOT_LISTED,
    pets: AMENITIES_AVAILABILITY_CONSTANTS.NOT_LISTED,
    pool: AMENITIES_AVAILABILITY_CONSTANTS.NOT_LISTED,
    laundry: AMENITIES_AVAILABILITY_CONSTANTS.NOT_LISTED,
    gym: AMENITIES_AVAILABILITY_CONSTANTS.NOT_LISTED,
});

const AMENITIES_TYPE_CONSTANTS = {
    LAUNDRY: 'LAUNDRY',
    CATS_ALLOWED: 'CATS_ALLOWED',
    SMALL_DOGS_ALLOWED: 'SMALL_DOGS_ALLOWED',
    LARGE_DOGS_ALLOWED: 'LARGE_DOGS_ALLOWED',
    PARKING_TYPE: 'PARKING_TYPE',
    SWIMMING_POOL: 'SWIMMING_POOL',
};

const nonParkingTypes = ['offStreet', 'none'];
const competitorData = (data) => {
    const returnData = [];

    data.properties.forEach((property) => {
        const modelledProperty = {
            name: property.street,
            amenities: makeDefaultAmenities(),
            models: property.models || [],
            timeSeries: property.timeSeries || [],
            totalContacts: property.totalContacts,
            lat: property.lat,
            lon: property.lon,
        };
        property.amenities.map((amenity) => {
            switch (amenity.type) {
                case AMENITIES_TYPE_CONSTANTS.LAUNDRY:
                    modelledProperty.amenities.laundry = AMENITIES_AVAILABILITY_CONSTANTS.YES;
                    break;
                case AMENITIES_TYPE_CONSTANTS.LARGE_DOGS_ALLOWED:
                case AMENITIES_TYPE_CONSTANTS.SMALL_DOGS_ALLOWED:
                case AMENITIES_TYPE_CONSTANTS.CATS_ALLOWED:
                    if (amenity.tag) {
                        modelledProperty.amenities.pets = AMENITIES_AVAILABILITY_CONSTANTS.YES;
                    }
                    break;
                case AMENITIES_TYPE_CONSTANTS.SWIMMING_POOL:
                    if (amenity.tag) {
                        modelledProperty.amenities.pool = AMENITIES_AVAILABILITY_CONSTANTS.YES;
                    }
                    break;
                case AMENITIES_TYPE_CONSTANTS.PARKING_TYPE:
                    if (nonParkingTypes.includes(amenity.tag)) {
                        modelledProperty.amenities.parking = AMENITIES_AVAILABILITY_CONSTANTS.NO;
                    } else {
                        modelledProperty.amenities.parking = AMENITIES_AVAILABILITY_CONSTANTS.YES;
                    }
                    break;
                default:
            }
            return null;
        });
        returnData.push(modelledProperty);
    });
    return {
        properties: returnData,
    };
};

export default competitorData;
